<template>

<div   >

  <nav class="navbar is-primary" role="navigation" aria-label="main navigation" style="background-color: #205081;">
    <div class="navbar-brand">

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <a class="navbar-item">
          Exodus
        </a>
      </div>
    </div>
  </nav>

<br>
  <div class="row container" align="center" style="background-color: white; height:90%;">

    <div align="center">
        <figure class="image is-128x128 tile is-2 hero">
          <img src="../../src/assets/images/logo.png">
        </figure>
    </div>

    <br><br><br><br><br>
      <div class="field tile is-5 level-item">
        <div class="control">
          <input v-model="mail" id="email" type="text" class="input is-rounded" placeholder="usuario">
        </div>
      </div>
      <div class="field tile is-5 level-item">
        <div class="control">
          <input v-model="pass" id="password" type="password" class="input is-rounded" placeholder="contraseña" @keyup.enter="login">
        </div>
      </div>

      <p v-if="errors2.length > 0" style="color:red;" >
       <ul>
         <li v-for="error in errors2"> ☒ {{ error }}</li>
       </ul>
      </p>

    <p class="level-item">
      <a class="button is-primary" @click="login" > Acceder </a>
    </p>

    <br>

  </div>
  <br>

</div>
</template>

<script>

import axios from 'axios'
import qs from 'qs'

import { EventBus } from './bus.js'

export default {
  data () {
    return {
      mail: '',
      pass: '',
      showModal: false,
      wrong: false,
      errors2: [],
      alturaVentana: window.innerHeight,
      host: 'exodustickets.sistemy.mx'

    }
  },
  methods: {
    login (e) {
      this.errors2 = []
      var estancia = this

      if (this.mail === '' || this.pass === '') {
        if (this.mail === '') {
          this.errors2.push('Ingrese un Correo')
        }
        if (this.pass === '') {
          this.errors2.push('Ingrese la contraseña')
        }
      } else {
        console.log(this.mail)
        console.log(this.pass)
        var params = {
          action : 'leerpost',
          select : `*`,
          table : "usuarios",
          where : ` nombre = '${this.mail}' AND password = '${this.pass}' `
        }
        axios.post(`https://${this.host}/assignFunction.php`,qs.stringify(params))
          .then( (response) => {
            if (response.status === 200) {
              if (response.data !== 'no hay datos') { console.log(response,'<--response de login')

                var user = {
                  id: response.data[0].id,
                  name: response.data[0].nombre,
                  email: response.data[0].email,
                }

                estancia.$cookies.set('RhSession', user) // return this
                this.$router.push('/')

                EventBus.$emit('passUser', 1)
              } else {
                estancia.errors2.push('Correo y/o Contraseña incorrecta')
              }

              console.log('respuesta read' + response.data[0].nombre)
              console.log('respuesta read' + response.data[0].rol_id)
            } else {
              console.log('error')
            }
          })

      }
      // e.preventDefault();
    }

  }

}
</script>
